import { render } from "./Grammar.vue?vue&type=template&id=742ee231&scoped=true"
import script from "./Grammar.vue?vue&type=script&lang=js"
export * from "./Grammar.vue?vue&type=script&lang=js"

import "./Grammar.vue?vue&type=style&index=0&id=742ee231&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742ee231"]])

export default __exports__